export default "__VITE_ASSET__q7RR3FM3__"